module.exports = __webpack_public_path__ + "static/media/sites.2cdfbd7a.svg";